[
	{
		"header": "Order Date time",
		"field": "dateRange",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Side",
		"field": "buySellCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "B-(buy)",
				"value": "B"
			},
			{
				"label": "SL-(sell long)",
				"value": "SL"
			},
			{
				"label": "SS-(short sale)",
				"value": "SS"
			},
			{
				"label": "SX-(short sale exempt)",
				"value": "SX"
			}
		]
	},
	{
		"header": "execution Price",
		"field": "executionPrice",
		"datatype": "Float",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "execution Quantity",
		"field": "executionQuantity",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "execution Timestamp",
		"field": "executionTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "router Terminal ID",
		"field": "routerTerminalID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "reported Exception Code",
		"field": "reportedExceptionCode",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "execution Type Indicator",
		"field": "executionTypeIndicator",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "F-(full execution)",
				"value": "F"
			},
			{
				"label": "P-(partial execution)",
				"value": "P"
			}
		]
	},
	{
		"header": "leaves Quantity",
		"field": "leavesQuantity",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "market Center ID",
		"field": "marketCenterID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "capacity Code",
		"field": "capacityCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "A-(Agent)",
				"value": "A"
			},
			{
				"label": "P-(Principal)",
				"value": "P"
			},
			{
				"label": "R-(Riskless Principal)",
				"value": "R"
			}
		]
	},
	{
		"header": "Branch Seq No",
		"field": "branchSeqNum",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routed Order ID",
		"field": "routedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Sent TO Routed Order ID",
		"field": "sentToRoutedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Record Type",
		"field": "recordType",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Action Type Code",
		"field": "actionTypeCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "C-(correct)",
				"value": "C"
			},
			{
				"label": "D-(delete)",
				"value": "D"
			},
			{
				"label": "N-(new)",
				"value": "N"
			},
			{
				"label": "R-(replacement)",
				"value": "R"
			}
		]
	},
	{
		"header": "Firm ROE ID",
		"field": "firmRoeID",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Correction Deletion Timestamp",
		"field": "correctionDeletionTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Resubmit",
		"field": "resubmit",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "Y-(yes)",
				"value": "Y"
			}
		]
	},
	{
		"header": "Order Receiving Date",
		"field": "orderReceivingDate",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Firm Order ID",
		"field": "firmOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routing Firm Mpid",
		"field": "routingFirmMpid",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Order Received Timestamp",
		"field": "orderReceivedTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Recv Method",
		"field": "receivedMethod",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "E-(Electronic)",
				"value": "E"
			},
			{
				"label": "N-(Manual)",
				"value": "N"
			}
		]
	},
	{
		"header": "Customer Instruction Flag",
		"field": "customerInstructionFlag",
		"datatype": "char",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	}
]